var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4267 19.4193C14.2597 19.4193 14.0973 19.3342 14.0048 19.1837C13.8752 18.9721 13.9199 18.6992 14.1092 18.5412C14.932 17.8584 15.4031 16.9119 15.4031 15.9459C15.4031 14.2182 14.4014 12.4741 12.1638 12.4741H11.9464V14.9546C11.9464 15.1543 11.8255 15.3362 11.6406 15.4122C11.4543 15.4882 11.2411 15.4465 11.0995 15.3049L6.13851 10.3439C5.94472 10.1501 5.94472 9.83558 6.13851 9.64179L11.0995 4.6808C11.2411 4.53918 11.4543 4.49595 11.6406 4.57347C11.8255 4.65098 11.9464 4.83135 11.9464 5.0326V7.0167C15.503 7.0167 18.3949 9.91011 18.3949 13.4654C18.3949 16.0547 16.9161 18.3759 14.625 19.3774C14.561 19.4058 14.4938 19.4193 14.4267 19.4193ZM11.45 11.4814H12.1638C14.6563 11.4814 16.3959 13.3178 16.3959 15.9459C16.3959 16.2516 16.3601 16.5556 16.2915 16.8522C17.0026 15.9205 17.4036 14.7444 17.4036 13.4654C17.4036 10.4572 14.9559 8.00949 11.9464 8.00949H11.45C11.1757 8.00949 10.9534 7.78738 10.9534 7.51309V6.22962L7.19093 9.99359L10.9534 13.7561V11.9778C10.9534 11.7034 11.1757 11.4814 11.45 11.4814Z",
    fill: "#00A3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.e3632548874a37e83e1f52f8e7b2e15f.svg";
export { ForwardRef as ReactComponent };